import { render } from "./FileSelectStep.vue?vue&type=template&id=f08f7094&scoped=true"
import script from "./FileSelectStep.vue?vue&type=script&lang=ts"
export * from "./FileSelectStep.vue?vue&type=script&lang=ts"

import "./FileSelectStep.vue?vue&type=style&index=0&id=f08f7094&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f08f7094"

export default script